/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 * Page dashboard translation constants
 *
 * @author Nikolay Sviridov
 * @version 1.34.0
 * @since 1.34.0
 */

import { IFastActionsPlateTranslation } from '@/main/components/FastActions/types/fastActionsTypes';

export const initTranslationFastActionsPlate: IFastActionsPlateTranslation = {
    roamSubs: '',
	noRoamSubs: '',
	createInquiry: '',
	bills: '',
	documents: '',
	advanceAccount: '',
	addPromicePayment: '',
	more: '',
};
